/* Created by Jessica Sheu
pauses and resumes video based off the window scrolling view
-tested to work for background-video section
-does not work for deferred media
add to <video-component> tag id="custom-video"
*/
document.addEventListener("scroll", function () {
    let videoComponent = document.getElementById("custom-video");
    if (!videoComponent) return;

    let video = videoComponent.querySelector("video");
    if (!video) return;

    let rect = videoComponent.getBoundingClientRect();
    let fullyAboveViewport = rect.bottom < 0; // Video fully scrolled past the top
    let fullyBelowViewport = rect.top > window.innerHeight; // Video fully scrolled past the bottom

    if (!fullyAboveViewport && !fullyBelowViewport) {
        if (video.paused) {
            console.log("Resuming Shopify video...");
            video.play().catch(err => console.error("Play error:", err));
        }
    } else {
        if (!video.paused) {
            console.log("Pausing Shopify video...");
            video.pause();
        }
    }
});

